type ArticleList<T> = {
  list: T[];
  sliceLimit?: number;
  removeDuplicates?: boolean;
};

type GetArticleListsConfig<T> = {
  featuredArticles?: ArticleList<T>;
  lists: ArticleList<T>[];
};

const removeDuplicateArticles = <T extends { key?: number }>(
  articles: T[],
  keys?: number[],
): T[] => {
  if (!keys) return articles;

  return articles.filter((article) => keys.indexOf(article?.key || 0) < 0);
};

const getArticleLists = <T extends { key?: number }>({
  featuredArticles = { list: [] },
  lists,
}: GetArticleListsConfig<T>): T[][] => {
  const coverArticles = featuredArticles.sliceLimit
    ? featuredArticles.list.slice(0, featuredArticles.sliceLimit)
    : featuredArticles.list;

  const coverArticleKeys = coverArticles
    .filter((article): article is T & { key: number } => !!article.key)
    .map((article) => article.key);

  const processedLists = lists.map(
    ({ list, sliceLimit, removeDuplicates: shouldRemoveDuplicates }) => {
      let result = list;

      if (shouldRemoveDuplicates) {
        result = removeDuplicateArticles<T>(list, coverArticleKeys);
      }

      return sliceLimit ? result.slice(0, sliceLimit) : result;
    },
  );

  return [coverArticles, ...processedLists];
};

export { getArticleLists, removeDuplicateArticles };
